import * as React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import InfoModal from '../../common/InfoModal';
import TileLoader from '../../common/tileLoader';
import * as types from "../../../constants/actionTypes";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import moment from "moment";

class FluVaccineTile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showInfoModel: false
        }

        this.toggleInfoModal = this.toggleInfoModal.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.FluTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }
    toggleInfoModal = () => {

        this.setState({
            showInfoModel: !this.state.showInfoModel
        })
    }
    modalFooter = () => {
        return (
            <div className="flu-vaccine-modal-button">
                <button type="button" className="btn text-btn" onClick={() => this.toggleInfoModal()}>OKAY</button>
            </div>
        )
    }
    modalBody = () => {
        return (
            <div className="flu-vaccine-modal-section">
                <p className="flu-vaccine-modal-bold">Employment Requirements</p>
                <p>All Baylor Scott & White Health employees, providers, and contractors must be vaccinated for influenza by <span className="flu-vaccine-modal-bold">{this.props.dueDate}</span> unless they have an approved exemption.</p>
                <p>The status reflects the latest information we have about you getting this year’s flu vaccine and sharing it with your employee health record (PeoplePlace) and/or electronic medical record (Epic):</p>
                <ul className="angle-bullets">
                    <li>
                        <span className="flu-vaccine-modal-bold">Not Started</span>
                        <p className="flu-vaccine-modal-li-text">We haven’t received proof that you have been vaccinated. You can give us early consent to have it transferred to your records as soon as we do.</p>
                    </li>
                    <li>
                        <span className="flu-vaccine-modal-bold">Consent Needed</span>
                        <p className="flu-vaccine-modal-li-text">We’ve received proof that you’ve been vaccinated but we need your consent to add it to your records.</p>
                    </li><li>
                        <span className="flu-vaccine-modal-bold">Consent Requested</span>
                        <p className="flu-vaccine-modal-li-text">We’ve received proof that you’ve been vaccinated, congrats! Although not required, giving consent to add this information to your medical record helps your provider deliver more informed, safer care.</p>
                    </li>
                    <li>
                        <span className="flu-vaccine-modal-bold">Vaccination Not On Record</span>
                        <p className="flu-vaccine-modal-li-text">We have your consent to add your proof of vaccination to your records, but we haven’t received it yet.</p>
                    </li>
                    <li>
                        <span className="flu-vaccine-modal-bold">Processing</span>
                        <p className="flu-vaccine-modal-li-text">We’ve received proof of you having received the vaccine and are waiting for the system to add to your record (the process can take up to 24 hours).</p>
                    </li>
                    <li>
                        <span className="flu-vaccine-modal-bold">Exempt</span>
                        <p className="flu-vaccine-modal-li-text">You have received a special exemption from HR saying you do not have to get the vaccine.</p>
                    </li>
                    <li>
                        <span className="flu-vaccine-modal-bold">Complete</span>
                        <p className="flu-vaccine-modal-li-text">You’ve done everything you need to. Way to go!</p>
                    </li>
                </ul>
                <p>Employees who receive the flu vaccine at a non-Baylor Scott & White Health facility will need to submit a Proof of Vaccination form (with all the required documentation) showing that a flu immunization was received after  <span className="flu-vaccine-modal-bold">Aug. 1, 2021</span> to <a href="mailto: eHealth@BSWHealth.org">eHealth@BSWHealth.org</a>.</p>
                <p>For questions about the flu vaccination employment requirement, call Employee Health at <a className="phone-link" href="tel:2148203323">214.820.3323</a> or visit <a target="_blank" href="https://bswconnect.com/flu">BSWconnect.</a></p>

            </div>
        )
    }


    render() {
        const { showInfoModel } = this.state;
        const { dueDate, isActiveFeature_FluShot, enableFluVaccine, status, statusText, showDismiss, showDueDate, showGiveConsent, fluStatusPending, fluStatusFailure } = this.props;
        let tileStatus = status;
        let tileStatusText = statusText;
        if (fluStatusFailure) {
            tileStatus = 'error',
                tileStatusText = "CHECK AGAIN LATER"
        }
        return (
            <>
                { isActiveFeature_FluShot && enableFluVaccine &&
                    <>
                        {fluStatusPending ? <TileLoader tilename="Employment Requirements" /> :
                            <div className="card flu-vaccine-tile">
                            {showDueDate && <><div className="due-date-feature">{`DUE ${dueDate}`}</div><div className="due-date-feature-after"></div></>}
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="card-heading">
                                                <span className="tooltip-link icon-question" onClick={(e) => this.toggleInfoModal()}></span>
                                                <div className="employment-flu-vaccine-tile-heading">Employment Requirements</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 tile-flu-image">
                                            <span className="svg-flu"></span>
                                            <span className="tile-flu-text">Flu Vaccination</span>
                                        </div>
                                        <div className={((showGiveConsent || showDismiss) ? "col-lg-5" : "col-lg-8") + " col-md-6 col-sm-6 col-xs-12 flu-vaccine-status-section"}>
                                            <span className="tile-flu-status-text">
                                                Status:
                                        </span>
                                            <span className={"tile-flu-status status-" + tileStatus}> {tileStatus === 'complete' && <span className="icon-check check-green" />} {tileStatusText}</span>
                                        </div>
                                        {showGiveConsent &&
                                            <div className="col-lg-3 col-md-12 col-sm-12 consent-section">
                                                <Link className="card-link" to="/fluconsent" onClick={() => logUI(`MBHWeb.UI.WellnessTile.FluConsent.Clicked`, new Date(), Tools.getURLPath())}>GIVE CONSENT</Link>
                                            </div>
                                        }
                                        {showDismiss &&
                                            <div className="col-lg-3 col-md-12 col-sm-12 consent-section">
                                                <a className="card-link" onClick={this.props.dismissFluTile}> DISMISS</a>
                                            </div>
                                        }
                                    </div>
                                </div>

                                <InfoModal isOpen={showInfoModel} toggle={this.toggleInfoModal}
                                    centered
                                    modalWidth="lg"
                                    className="flu-info-modal"
                                    modalBody={this.modalBody()}
                                    modalFooter={this.modalFooter()}
                                >
                                </InfoModal>
                            </div>}
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        enableFluVaccine: state.session.serverData.enableFluVaccine,
        isActiveFeature_FluShot: state.memberships.isActiveFeature_FluShot,
        fluStatusPending: state.portal.fluStatusPending,
        fluStatusFailure: state.portal.fluStatusFailure,
        hasMyChart: !state.common.epicEHRDown && state.domain.hm,
        statusText: state.portal.fluStatusSummary?.statusText ? state.portal.fluStatusSummary.statusText : "",
        status: state.portal.fluStatusSummary?.status ? state.portal.fluStatusSummary.status : "",
        showDueDate: state.portal.fluStatusSummary?.showDueFlag ? state.portal.fluStatusSummary.showDueFlag : false,
        dueDate: state.portal.fluStatusSummary?.fluShotDueDate ? moment(state.portal.fluStatusSummary.fluShotDueDate).format("MM/DD/YYYY") : '11/12/2021',
        showDismiss: state.portal.fluStatusSummary?.showDismiss ? state.portal.fluStatusSummary.showDismiss : false,
        showGiveConsent: state.portal.fluStatusSummary?.showGiveConsent ? state.portal.fluStatusSummary.showGiveConsent : false,
        medicalRecordStatus: state.portal.fluStatusSummary ? state.portal.fluStatusSummary.medicalRecordStatus : null,
    };
};


export default connect(mapStateToProps)(FluVaccineTile);